/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectDomainStats
 */
export interface ProjectDomainStats {
    /**
     * 
     * @type {number}
     * @memberof ProjectDomainStats
     */
    orderCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectDomainStats
     */
    adCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectDomainStats
     */
    campaignCount?: number;
}

/**
 * Check if a given object implements the ProjectDomainStats interface.
 */
export function instanceOfProjectDomainStats(value: object): value is ProjectDomainStats {
    return true;
}

export function ProjectDomainStatsFromJSON(json: any): ProjectDomainStats {
    return ProjectDomainStatsFromJSONTyped(json, false);
}

export function ProjectDomainStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDomainStats {
    if (json == null) {
        return json;
    }
    return {
        
        'orderCount': json['orderCount'] == null ? undefined : json['orderCount'],
        'adCount': json['adCount'] == null ? undefined : json['adCount'],
        'campaignCount': json['campaignCount'] == null ? undefined : json['campaignCount'],
    };
}

export function ProjectDomainStatsToJSON(json: any): ProjectDomainStats {
    return ProjectDomainStatsToJSONTyped(json, false);
}

export function ProjectDomainStatsToJSONTyped(value?: ProjectDomainStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderCount': value['orderCount'],
        'adCount': value['adCount'],
        'campaignCount': value['campaignCount'],
    };
}

